/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconRadiusTopLeft = createReactComponent("radius-top-left", "IconRadiusTopLeft", [
  ["path", { d: "M5 19v-6a8 8 0 0 1 8 -8h6", key: "svg-0" }]
]);

export { IconRadiusTopLeft as default };
//# sourceMappingURL=IconRadiusTopLeft.js.map
